import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { PharmacieAuthDto } from '../DTO/pharmacie.auth.dto';
import { PharmacieService } from '../service/pharmacie.service';


@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {

  code: string;
  pharmacieAuth: PharmacieAuthDto = new PharmacieAuthDto;

  public authForm: FormGroup;
  public submitted = false;
  public wrongCode = false;
  public sending = false;

  constructor(
    private router: Router,
    private pharmacieService: PharmacieService,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.authForm = this.formBuilder.group({
      code: this.formBuilder.control(this.code, [Validators.required])
    });
    this.pharmacieService.getMeForAuth().subscribe(data => {
      this.pharmacieAuth = PharmacieAuthDto.fromJson(data);
    }, err => {
      console.log(err);
    });
  }

  get field() {
    return this.authForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    
    // stop here if form is invalid
    if (this.authForm.invalid) {
      return;
    }

    this.sending = true;
    this.wrongCode = false;
    this.pharmacieService.sendAuthCode(this.authForm.value.code)
    .pipe(finalize(() => this.sending = false))
    .subscribe(data => {
        this.router.navigate(["/"]);
      }, err => {
        this.wrongCode = true;
      }
    );
  }

}
